export const RoleConvertor: { [key: string]: string } = {
    mgr: 'مدیر',
    nrm: '',
    own: 'ایجاد کننده',
}
